const LocalStorage = {
  setFlag(key: string) {
    this.set(key, 'true');
  },

  isFlagSet(key: string) {
    return this.get(key) === 'true';
  },

  get(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },

  set(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {}
  },

  remove(key: 'authError') {
    try {
      localStorage.removeItem(key);
    } catch (err) {}
  },
};

export default LocalStorage;
